




































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import DateInput from '@/components/inputs/DateInput.vue'

@Component({
  props: {
    deposit: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    DateInput
  }
})
export default class PostInPccModal extends Vue {
  effectiveDate: Date | null = new Date()

  mounted () {
    this.effectiveDate = new Date(this.$props.deposit.depositDate.replace('Z', ''))
  }

  changeEffectiveDate (date: Date | string | null | undefined) {
    this.effectiveDate = date ? new Date(date) : null
  }

  confirm () {
    if (!this.effectiveDate) return
    this.$emit('confirm', this.effectiveDate)
  }
}
